import React from 'react'

const ESDPCBRack = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">ESD Lab Setup</a>
                        <i class="fa fa-angle-right"></i>
                        <span>ESD PCB Rack</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/pcbrack.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>ESD PCB Rack:</h2>
                        <p className="mbot25">
                            <b style={{ textDecoration: "underline", marginRight: '5px' }}>Description:</b>
                            An ESD PCB (Printed Circuit Board) rack is
                            essential for storing and organizing PCBs in an ESD-safe
                            manner. These racks are made from conductive materials
                            that prevent static buildup and safely dissipate any
                            electrostatic charges. They are designed to securely hold
                            PCBs, ensuring that the components are protected from ESD
                            damage during storage and transportation within the lab.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ESDPCBRack
